import { useContext } from "react"
import tw from "twin.macro"
import { LocationSelector } from "../../molecules/LocationSelector"
import { RadiusSelector } from "../../molecules/RadiusSelector"
import StaticFilter from "./StaticFilter"
import { LanguageContext } from "../../../contexts/Language"

const Distance = () => {
  const { _ } = useContext(LanguageContext)

  return (
    <StaticFilter title="Starting Zip Code" initialExpanded={true}>
      <span css={[tw`md:(grid grid-cols-2 gap-12)`]}>
        <LocationSelector
          location="inventory"
          focusColor={"gray"}
          analyticsId="filter modal"
          mainContainerStyles={tw`md:(pb-10)`}
          labelStyles={tw`pt-0`}
          inputSubmitInnerContainerStyles={tw`lg:(w-full)`}
          inputStyles={tw`lg:(w-full)`}
          inputSubmitOuterContainerStyles={tw`grid grid-cols-[2fr 1fr] gap-10 md:(pb-3) lg:(w-full)`}
          useLocationStyles={tw`md:(bottom-[-1.5rem])`}
        />
        <div css={[tw`my-5`]}>
          <h5 css={[tw`text-sm mt-0 font-semibold inline capitalize`]}>
            {_("Search Distance")}
          </h5>
          <RadiusSelector fromInventory={true} />
        </div>
      </span>
    </StaticFilter>
  )
}

export default Distance
